export const quantumPageEN = {
  "seo": {
    "title": "Sovereign LLMs & Quantum AI | pAIoneer Labs GmbH",
    "description": "Our goal from Germany: under Veridion ('AI develops AI further'), developing compact sovereign language models and Quantum Transformers that will compete with large models from the US and China."
  },
  "hero": {
    "kicker": "Made in Germany · AI Develops AI",
    "title": "Sovereign LLMs & Quantum AI",
    "claim": "Our goal from Germany: to develop our own language models and Quantum Transformers that will compete with the large frontier models from the US and China.",
    "subtitle": "In real enterprise projects, existing European approaches — the German models from Aleph Alpha (such as Kolibri), the French models around Mistral, EuroLLM, and especially Switzerland's Apertus — were benchmarked against practical company problems. None met enterprise requirements. Under [Veridion](veridion) (“AI develops AI further”), our AI is taking the next step: researching and engineering the path toward compact language models Made in Germany that will be far stronger than the French models, while developing our own Quantum Transformers as our second core focus.",
    "cta": "Schedule a conversation"
  },
  "pillars": {
    "title": "What Our AI Is Working On",
    "subtitle": "Two research focuses in which our digital colleagues design novel architectures, test them in simulation, and build them step by step.",
    "items": [
      {
        "title": "What a Language Model Must Deliver in Practice",
        "description": "In production, multi-step logical reasoning, reliable tool use across long workflows, clean software engineering, and error-free office processes are what count. Every architecture is measured against these from day one."
      },
      {
        "title": "Compact Models for Your Own Infrastructure",
        "description": "Instead of ever-larger data centers, our goal will be to pack deep reasoning capability into a compact model that enterprises can run locally on their own hardware."
      },
      {
        "title": "Quantum Transformers & Quantum AI",
        "description": "In our second focus area, we research how transformer architectures can be combined with parameterized quantum circuits and tensor networks to open up model classes beyond classical networks."
      },
      {
        "title": "Own Quantum IDE & Real Quantum Processors",
        "description": "In our in-house Quantum IDE, our AI colleagues design, simulate, and test new quantum circuits against classical baselines before running them on real quantum hardware."
      }
    ]
  },
  "gate": {
    "title": "From Research State to Blueprint",
    "subtitle": "Every engineering step builds on verified literature, our company memory, and measurable comparisons.",
    "stages": [
      {
        "step": "Step 01",
        "title": "Literature Analysis & Company Memory",
        "description": "Our AI colleagues continuously evaluate the latest scientific papers on language model and quantum architectures, storing all verified findings in our company knowledge graph."
      },
      {
        "step": "Step 02",
        "title": "Training Blueprint & Circuit Simulation",
        "description": "Together with Product Development, this turns into the detailed training roadmap for our future language model while new quantum circuits are tested in parallel in our Quantum IDE."
      },
      {
        "step": "Step 03",
        "title": "Scientific Review in the IDD Process",
        "description": "Human physicists and AI researchers audit every hypothesis, measurement, and design via [Intent-Driven Development](idd) (IDD) as human-in-the-loop and approve the next step."
      }
    ]
  },
  "stack": {
    "title": "Humans and AI in One Research Unit",
    "subtitle": "Research, product engineering, and scientific oversight interlock in fixed cycles.",
    "items": [
      {
        "title": "Digital Researchers Around the Clock",
        "description": "Specialized AI colleagues handle literature research, mathematical derivations, circuit design, and empirical evaluation day and night."
      },
      {
        "title": "Physicists in the Human-in-the-Loop",
        "description": "Human scientists set the research direction, challenge assumptions, and decide on approvals, hardware runs, and publications."
      },
      {
        "title": "Interlocked With Product Development",
        "description": "In close alignment with Product Development, validated research results flow directly into our tools and future enterprise solutions."
      },
      {
        "title": "Traceable Down to the Source",
        "description": "Every architectural decision, discarded variant, and benchmark result remains permanently documented and auditable by both humans and AI."
      }
    ]
  },
  "cta": {
    "title": "Research Exchange",
    "subtitle": "Interested in discussing our research on sovereign language models and Quantum Transformers? Write to us.",
    "button": "Send a message"
  }
};
